import {NatGetCondominiumGroup} from './NatGetCondominiumGroup'
import {NatPostCondominiumGroupParams, NatPostCondominiumGroupResponse} from './NatPostCondominiumGroup'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'

export default class NatCondominiumGroupRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 物件グループマスタ一覧取得
    async getCondominiumGroup([condominiumGroupId]: number[] = []): Promise<NatGetCondominiumGroup> {
        const query = condominiumGroupId ? `?condominiumGroupId=${condominiumGroupId}` : ''
        return await this.http.get(`/api/common/condominiumGroup${query}`)
    }

    // 引き継ぎ物件グループ一覧取得
    async getSubCondominiumGroup(): Promise<NatGetCondominiumGroup> {
        return await this.http.get(`/api/common/subCondominiumGroup`)
    }

    // 物件グループマスタ一括反映
    async postCondominiumGroup(requestParam: NatPostCondominiumGroupParams): Promise<NatPostCondominiumGroupResponse> {
        return await this.http.post(`/api/admin/condominiumGroup`,
            {
                registerCondominiumGroup: requestParam.registerCondominiumGroup,
                updateCondominiumGroup: requestParam.updateCondominiumGroup,
                deleteCondominiumGroup: requestParam.deleteCondominiumGroup,
            },
            ContentType.JSON,
        )
    }

}
